import { CalendarField, TextInputField } from "../../../helpers"
import Messages from "../../../helpers/Messages"


const EmailRecipientDetails = (props) => {

    const { requirement, handleRequirementChange } = props

    const lastMonthDate = new Date()
    lastMonthDate.setMonth(new Date().getMonth() - 1)
    const nextMonthDate = new Date()
    nextMonthDate.setMonth(new Date().getMonth() + 1)

    return (
        <>
            <hr style={{ height: '1px', border: 'none', backgroundColor: '#ccc' }} />
            <Messages messages={"No Ticket Id Found. Please Enter Email Details Manually.(This helps us track communication when no ticket is raised in the system)"} sticky severity="warn" />
            <div className="flex flex-column col-12">
                <TextInputField name="emailSubject" labelText='Email Subject' value={requirement.emailSubject} onChange={(e) => handleRequirementChange(e)} required />
            </div>
            <div className="flex flex-column col-12">
                <TextInputField name="emailRecipient" labelText='Email Recipient' value={requirement.emailRecipient} onChange={(e) => handleRequirementChange(e)} maxLength={50} required />
            </div>
            <div className="flex flex-column col-12">
                <CalendarField name="emailDateStamp" labelText="Email Date Stamp" value={requirement.emailDateStamp} dateFormat='dd/mm/yy' minDate={lastMonthDate} maxDate={nextMonthDate} onChange={handleRequirementChange} showTime hourFormat="12" showIcon required />
            </div>
            <hr style={{ height: '1px', border: 'none', backgroundColor: '#ccc' }} />
        </>
    )
}

export default EmailRecipientDetails